import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const cid = localStorage.getItem("pp_company");
  if (cid) config.headers["X-Company-Id"] = cid;
  return config;
});

export function setToken(t) { t ? localStorage.setItem("pp_token", t) : localStorage.removeItem("pp_token"); }
export function setActiveCompany(c) { c ? localStorage.setItem("pp_company", c) : localStorage.removeItem("pp_company"); }

export const api = {
  login: (body) => http.post("/auth/login", body).then((r) => r.data),
  verify2fa: (b) => http.post("/auth/verify-2fa", b).then((r) => r.data),
  ssoExchange: (b) => http.post("/auth/sso/exchange", b).then((r) => r.data),
  twofaStatus: () => http.get("/auth/2fa/status").then((r) => r.data),
  twofaEnableStart: () => http.post("/auth/2fa/enable/start").then((r) => r.data),
  twofaEnableConfirm: (b) => http.post("/auth/2fa/enable/confirm", b).then((r) => r.data),
  twofaDisable: () => http.post("/auth/2fa/disable").then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  savePreferences: (b) => http.patch("/auth/preferences", b).then((r) => r.data),
  saveCompanyLocale: (b) => http.patch("/company/locale", b).then((r) => r.data),
  getFxRate: () => http.get("/platform/fx-rate").then((r) => r.data),
  setFxRate: (b) => http.patch("/platform/fx-rate", b).then((r) => r.data),
  forgotPassword: (b) => http.post("/auth/forgot-password", b).then((r) => r.data),
  resetPassword: (b) => http.post("/auth/reset-password", b).then((r) => r.data),
  tokenInfo: (token) => http.get("/auth/token-info", { params: { token } }).then((r) => r.data),
  companies: () => http.get("/companies").then((r) => r.data),
  myCompanies: () => http.get("/companies/mine").then((r) => r.data),
  addCompanyCheckout: (b) => http.post("/subscription/company/checkout", b).then((r) => r.data),
  addCompanyStatus: (sid) => http.get(`/subscription/company/status/${sid}`).then((r) => r.data),
  requestAccess: (cid, b) => http.post(`/platform/companies/${cid}/request-access`, b).then((r) => r.data),
  accessStatus: (cid) => http.get(`/platform/companies/${cid}/access-status`).then((r) => r.data),
  getConsentRequest: (token) => http.get(`/access-consent/${token}`).then((r) => r.data),
  respondConsent: (token, b) => http.post(`/access-consent/${token}`, b).then((r) => r.data),
  platformTickets: (q) => http.get("/platform/tickets", { params: q }).then((r) => r.data),
  platformTicketDetail: (tid) => http.get(`/platform/tickets/${tid}`).then((r) => r.data),
  platformTicketUpdate: (tid, b) => http.patch(`/platform/tickets/${tid}`, b).then((r) => r.data),
  ticketAi: (tid, b) => http.post(`/platform/tickets/${tid}/ai`, b).then((r) => r.data),
  createCompany: (b) => http.post("/companies", b).then((r) => r.data),
  users: () => http.get("/admin/users").then((r) => r.data),
  createUser: (b) => http.post("/admin/users", b).then((r) => r.data),
  updateUser: (id, b) => http.patch(`/admin/users/${id}`, b).then((r) => r.data),
  deleteUser: (id) => http.delete(`/admin/users/${id}`).then((r) => r.data),
  plans: () => http.get("/plans").then((r) => r.data),
  createLead: (b) => http.post("/leads", b).then((r) => r.data),
  platformOverview: () => http.get("/platform/overview").then((r) => r.data),
  platformCompanies: () => http.get("/platform/companies").then((r) => r.data),
  updatePlatformCompany: (id, b) => http.patch(`/platform/companies/${id}`, b).then((r) => r.data),
  impersonate: (id) => http.post(`/platform/impersonate/${id}`).then((r) => r.data),
  technicians: () => http.get("/platform/technicians").then((r) => r.data),
  createTechnician: (b) => http.post("/platform/technicians", b).then((r) => r.data),
  updateTechnician: (id, b) => http.patch(`/platform/technicians/${id}`, b).then((r) => r.data),
  deleteTechnician: (id) => http.delete(`/platform/technicians/${id}`).then((r) => r.data),
  errorLogs: (q) => http.get("/platform/error-logs", { params: q }).then((r) => r.data),
  updateErrorLog: (id, b) => http.patch(`/platform/error-logs/${id}`, b).then((r) => r.data),
  techOverview: () => http.get("/platform/tech-overview").then((r) => r.data),
  chatStart: () => http.post("/chat/start").then((r) => r.data),
  chatMessage: (sid, content) => http.post(`/chat/${sid}/message`, { content }).then((r) => r.data),
  chatPoll: (sid) => http.get(`/chat/${sid}`).then((r) => r.data),
  chatClose: (sid) => http.post(`/chat/${sid}/close`).then((r) => r.data),
  chatTyping: (sid) => http.post(`/chat/${sid}/typing`).then((r) => r.data),
  platformChats: (status) => http.get("/platform/chats", { params: status ? { status } : {} }).then((r) => r.data),
  platformChatDetail: (sid) => http.get(`/platform/chats/${sid}`).then((r) => r.data),
  platformChatJoin: (sid) => http.post(`/platform/chats/${sid}/join`).then((r) => r.data),
  platformChatMessage: (sid, content) => http.post(`/platform/chats/${sid}/message`, { content }).then((r) => r.data),
  platformChatClose: (sid) => http.post(`/platform/chats/${sid}/close`).then((r) => r.data),
  platformChatTyping: (sid) => http.post(`/platform/chats/${sid}/typing`).then((r) => r.data),
  vapidPublic: () => http.get("/push/vapid-public").then((r) => r.data),
  pushSubscribe: (subscription) => http.post("/push/subscribe", { subscription }).then((r) => r.data),
  pushUnsubscribe: (subscription) => http.post("/push/unsubscribe", { subscription }).then((r) => r.data),
  platformLeads: () => http.get("/platform/leads").then((r) => r.data),
  updateLead: (id, b) => http.patch(`/platform/leads/${id}`, b).then((r) => r.data),
  subscription: () => http.get("/subscription").then((r) => r.data),
  checkout: (b) => http.post("/subscription/checkout", b).then((r) => r.data),
  subscriptionInvoices: () => http.get("/subscription/invoices").then((r) => r.data),
  billingPortal: (origin_url) => http.post("/subscription/portal", { origin_url }).then((r) => r.data),
  checkoutStatus: (sid) => http.get(`/subscription/status/${sid}`).then((r) => r.data),
  signupCheckout: (b) => http.post("/signup/checkout", b).then((r) => r.data),
  signupStatus: (sid) => http.get(`/signup/status/${sid}`).then((r) => r.data),
  getContract: () => http.get("/contract").then((r) => r.data),
  contractPdf: async () => {
    const res = await http.get("/contract/pdf", { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = "contrat-progere-punch.pdf"; a.click(); URL.revokeObjectURL(url);
  },
  contractAcceptances: () => http.get("/contract/acceptances").then((r) => r.data),
  acceptancePdf: async (id) => {
    const res = await http.get(`/contract/acceptances/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `contrat-signe-${id.slice(0, 8)}.pdf`; a.click(); URL.revokeObjectURL(url);
  },
  platformContracts: () => http.get("/platform/contracts").then((r) => r.data),
  platformContractPdf: async (id) => {
    const res = await http.get(`/platform/contracts/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `contrat-signe-${id.slice(0, 8)}.pdf`; a.click(); URL.revokeObjectURL(url);
  },
  assistantChat: (b) => http.post("/assistant/chat", b).then((r) => r.data),
  dashboard: () => http.get("/dashboard").then((r) => r.data),
  employees: () => http.get("/employees").then((r) => r.data),
  myEmployee: () => http.get("/employees/me").then((r) => r.data),
  employeeDetail: (id) => http.get(`/employees/${id}`).then((r) => r.data),
  updateEmployee: (id, b) => http.patch(`/employees/${id}`, b).then((r) => r.data),
  deactivateEmployee: (id) => http.post(`/employees/${id}/deactivate`).then((r) => r.data),
  inviteEmployee: (id, origin_url) => http.post(`/employees/${id}/invite`, { origin_url }).then((r) => r.data),
  employeeAbsences: (id) => http.get(`/employees/${id}/absences`).then((r) => r.data),
  addAbsence: (id, b) => http.post(`/employees/${id}/absences`, b).then((r) => r.data),
  deleteAbsence: (id, aid) => http.delete(`/employees/${id}/absences/${aid}`).then((r) => r.data),
  employeeFiles: (id) => http.get(`/employees/${id}/files`).then((r) => r.data),
  uploadEmployeeFile: (id, file, kind = "document") => {
    const fd = new FormData(); fd.append("file", file); fd.append("kind", kind);
    return http.post(`/employees/${id}/files`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  employeeFileBlobUrl: async (fid) => {
    const res = await http.get(`/employees/files/${fid}`, { responseType: "blob" });
    return URL.createObjectURL(res.data);
  },
  deleteEmployeeFile: (fid) => http.delete(`/employees/files/${fid}`).then((r) => r.data),
  employeePdf: async (id) => {
    const res = await http.get(`/employees/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `fiche-employe.pdf`; a.click(); URL.revokeObjectURL(url);
  },
  updateEmployeeCcq: (id, b) => http.patch(`/employees/${id}/ccq`, b).then((r) => r.data),
  projects: () => http.get("/projects").then((r) => r.data),
  createProject: (b) => http.post("/projects", b).then((r) => r.data),
  updateProject: (id, b) => http.patch(`/projects/${id}`, b).then((r) => r.data),
  deleteProject: (id) => http.delete(`/projects/${id}`).then((r) => r.data),
  schedules: () => http.get("/schedules").then((r) => r.data),
  createSchedule: (b) => http.post("/schedules", b).then((r) => r.data),
  updateSchedule: (id, b) => http.patch(`/schedules/${id}`, b).then((r) => r.data),
  deleteSchedule: (id) => http.delete(`/schedules/${id}`).then((r) => r.data),
  chantierDetail: (id) => http.get(`/chantiers/${id}`).then((r) => r.data),
  chantiers: () => http.get("/chantiers").then((r) => r.data),
  createChantier: (b) => http.post("/chantiers", b).then((r) => r.data),
  updateChantier: (id, b) => http.patch(`/chantiers/${id}`, b).then((r) => r.data),
  describeChantier: (id) => http.post(`/chantiers/${id}/describe`).then((r) => r.data),
  costCodes: () => http.get("/cost-codes").then((r) => r.data),
  createCostCode: (b) => http.post("/cost-codes", b).then((r) => r.data),
  updateCostCode: (id, b) => http.patch(`/cost-codes/${id}`, b).then((r) => r.data),
  deleteCostCode: (id) => http.delete(`/cost-codes/${id}`).then((r) => r.data),
  punches: (params) => http.get("/punches", { params }).then((r) => r.data),
  punch: (b) => http.post("/punch", b).then((r) => r.data),
  correctPunch: (id, b) => http.patch(`/punches/${id}`, b).then((r) => r.data),
  timesheets: (params) => http.get("/timesheets", { params }).then((r) => r.data),
  timesheetDetail: (id) => http.get(`/timesheets/${id}/detail`).then((r) => r.data),
  exportTimesheet: async (id, fmt) => {
    const res = await http.get(`/timesheets/${id}/export.${fmt}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `feuille-${id.slice(0, 8)}.${fmt}`; a.click(); URL.revokeObjectURL(url);
  },
  exportPayrollCsv: async (status = "") => {
    const res = await http.get(`/payroll/export.csv`, { params: { status }, responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `export-paie.csv`; a.click(); URL.revokeObjectURL(url);
  },
  submitTs: (id) => http.post(`/timesheets/${id}/submit`).then((r) => r.data),
  approveTs: (id) => http.post(`/timesheets/${id}/approve`, {}).then((r) => r.data),
  rejectTs: (id, b) => http.post(`/timesheets/${id}/reject`, b).then((r) => r.data),
  anomalies: () => http.get("/anomalies").then((r) => r.data),
  notifications: () => http.get("/notifications").then((r) => r.data),
  myAccessRequests: () => http.get("/access-requests").then((r) => r.data),
  respondAccessRequest: (id, consent) => http.post(`/access-requests/${id}/respond`, { consent }).then((r) => r.data),
  getGeofence: () => http.get("/settings/geofence").then((r) => r.data),
  setGeofence: (b) => http.put("/settings/geofence", b).then((r) => r.data),
  tts: (text, voice) => http.post("/tts", { text, voice }, { responseType: "blob" }).then((r) => r.data),
  appVersion: () => http.get("/app-version").then((r) => r.data),
  markVersionSeen: () => http.post("/app-version/seen").then((r) => r.data),
  platformReleases: () => http.get("/platform/releases").then((r) => r.data),
  releaseHistory: () => http.get("/app-version/history").then((r) => r.data),
  publishRelease: (b) => http.post("/platform/releases", b).then((r) => r.data),
  deleteRelease: (id) => http.delete(`/platform/releases/${id}`).then((r) => r.data),
  search: (q) => http.get("/search", { params: { q } }).then((r) => r.data),
  auditLogs: () => http.get("/audit-logs").then((r) => r.data),
  exports: () => http.get("/exports").then((r) => r.data),
  accountingExport: (format) => http.get("/accounting/export", { params: { format }, responseType: "blob" }),
  getAccountingMapping: () => http.get("/accounting/mapping").then((r) => r.data),
  setAccountingMapping: (b) => http.patch("/accounting/mapping", b).then((r) => r.data),
  accountingConnectorExport: (provider) => http.get("/accounting/connector-export", { params: { provider }, responseType: "blob" }),
  getApiKey: () => http.get("/integrations/apikey").then((r) => r.data),
  rotateApiKey: () => http.post("/integrations/apikey/rotate").then((r) => r.data),
  listApiKeys: () => http.get("/integrations/keys").then((r) => r.data),
  createApiKey: (b) => http.post("/integrations/keys", b).then((r) => r.data),
  deleteApiKey: (id) => http.delete(`/integrations/keys/${id}`).then((r) => r.data),
  inboundConfig: () => http.get("/integrations/inbound").then((r) => r.data),
  rotateInboundSecret: () => http.post("/integrations/inbound/rotate-secret").then((r) => r.data),
  inboundEvents: () => http.get("/integrations/inbound/events").then((r) => r.data),
  webhookEvents: () => http.get("/webhooks/events").then((r) => r.data),
  webhooks: () => http.get("/webhooks").then((r) => r.data),
  createWebhook: (b) => http.post("/webhooks", b).then((r) => r.data),
  updateWebhook: (id, b) => http.patch(`/webhooks/${id}`, b).then((r) => r.data),
  deleteWebhook: (id) => http.delete(`/webhooks/${id}`).then((r) => r.data),
  testWebhook: (id) => http.post(`/webhooks/${id}/test`).then((r) => r.data),
  webhookDeliveries: () => http.get("/webhooks/deliveries").then((r) => r.data),
  exportPayroll: (b) => http.post("/payroll/export", b).then((r) => r.data),
  reports: () => http.get("/reports/summary").then((r) => r.data),
  aiAnalyze: () => http.post("/ai/analyze").then((r) => r.data),
  loi25Summary: () => http.get("/loi25/summary").then((r) => r.data),
  consents: () => http.get("/loi25/consents").then((r) => r.data),
  setConsent: (b) => http.post("/loi25/consents", b).then((r) => r.data),
  incidents: () => http.get("/loi25/incidents").then((r) => r.data),
  createIncident: (b) => http.post("/loi25/incidents", b).then((r) => r.data),
  resolveIncident: (id) => http.post(`/loi25/incidents/${id}/resolve`).then((r) => r.data),
  setOfficer: (b) => http.put("/loi25/officer", b).then((r) => r.data),
  dsar: (b) => http.post("/loi25/dsar", b).then((r) => r.data),
  complianceStatus: () => http.get("/legal/compliance-status").then((r) => r.data),
  publicPrivacyRequests: () => http.get("/legal/privacy-requests").then((r) => r.data),
  updatePrivacyRequest: (id, b) => http.patch(`/legal/privacy-requests/${id}`, b).then((r) => r.data),
  submitPrivacyRequest: (b) => http.post("/legal/privacy-request", b).then((r) => r.data),
  logConsent: (b) => http.post("/legal/consent", b).then((r) => r.data),
  backups: () => http.get("/backups").then((r) => r.data),
  createBackup: () => http.post("/backups").then((r) => r.data),
  restoreBackup: (id) => http.post(`/backups/${id}/restore`).then((r) => r.data),
  downloadBackup: (id) => http.get(`/backups/${id}/download`).then((r) => r.data),
  emailSettings: () => http.get("/settings/email").then((r) => r.data),
  ecoLinks: () => http.get("/eco-links").then((r) => r.data),
  setEcoLink: (b) => http.put("/eco-links", b).then((r) => r.data),
  emailStatus: () => http.get("/integrations/email-status").then((r) => r.data),
  setEmailSettings: (b) => http.put("/settings/email", b).then((r) => r.data),
  sendEmail: (b) => http.post("/email/send", b).then((r) => r.data),
  reportsExcel: async (kind) => {
    const res = await http.get("/reports/excel", { params: { kind }, responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `${kind === "journal" ? "journal_comptable" : "paie"}.xlsx`; a.click(); URL.revokeObjectURL(url);
  },
  ccqMonthly: async (format = "xlsx") => {
    const res = await http.get("/reports/ccq-monthly", { params: { format }, responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `rapport_mensuel_ccq.${format}`; a.click(); URL.revokeObjectURL(url);
  },
  ccqCompliance: () => http.get("/ccq/compliance").then((r) => r.data),
  ecosystemModules: () => http.get("/ecosystem/modules").then((r) => r.data),
  deletionRequest: () => http.get("/account/deletion-request").then((r) => r.data),
  createDeletionRequest: (b) => http.post("/account/deletion-request", b).then((r) => r.data),
  cancelDeletionRequest: () => http.delete("/account/deletion-request").then((r) => r.data),
  exportMyData: async () => {
    const res = await http.get("/account/export", { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = "progere-mes-donnees.json"; a.click(); URL.revokeObjectURL(url);
  },
  aiCcqAnalysis: () => http.post("/ai/ccq-analysis").then((r) => r.data),
  verifyAuditChain: () => http.get("/security/audit/verify").then((r) => r.data),
  createSupportTicket: (b) => http.post("/support/tickets", b).then((r) => r.data),
  supportMeta: () => http.get("/support/meta").then((r) => r.data),
  accountantCodeStatus: () => http.get("/accountant/code/status").then((r) => r.data),
  generateAccountantCode: () => http.post("/accountant/code/generate").then((r) => r.data),
  createChangeRequest: (b) => http.post("/accountant/change-requests", b).then((r) => r.data),
  changeRequests: () => http.get("/accountant/change-requests").then((r) => r.data),
  changeRequestsPending: () => http.get("/accountant/change-requests/pending-count").then((r) => r.data),
  approveChangeRequest: (id, b) => http.post(`/accountant/change-requests/${id}/approve`, b || {}).then((r) => r.data),
  rejectChangeRequest: (id, b) => http.post(`/accountant/change-requests/${id}/reject`, b || {}).then((r) => r.data),
  supportTickets: () => http.get("/support/tickets").then((r) => r.data),
  mySupportTickets: () => http.get("/support/my-tickets").then((r) => r.data),
  supportTicketDetail: (id) => http.get(`/support/tickets/${id}`).then((r) => r.data),
  addSupportTicketMessage: (id, b) => http.post(`/support/tickets/${id}/messages`, b).then((r) => r.data),
  updateSupportTicket: (id, b) => http.patch(`/support/tickets/${id}`, b).then((r) => r.data),
  cloudCatalog: () => http.get("/cloud/catalog").then((r) => r.data),
  cloudStatus: () => http.get("/cloud/status").then((r) => r.data),
  cloudActiveContract: () => http.get("/cloud/contracts/active").then((r) => r.data),
  cloudAcceptContract: (b) => http.post("/cloud/contracts/accept", b).then((r) => r.data),
  cloudMicrosoftStart: (b) => http.post("/cloud/microsoft/start", b).then((r) => r.data),
  cloudProviderStart: (provider, b) => http.post(`/cloud/${provider}/start`, b || {}).then((r) => r.data),
  msActivationStatus: () => http.get("/cloud/microsoft/activation").then((r) => r.data),
  msActivationRequest: (b) => http.post("/cloud/microsoft/activation-request", b).then((r) => r.data),
  msActivationAcceptFees: (b) => http.post("/cloud/microsoft/activation/accept-fees", b).then((r) => r.data),
  msActivationsList: (status) => http.get("/cloud/microsoft/activations", { params: status ? { status } : {} }).then((r) => r.data),
  msActivationAction: (id, b) => http.post(`/cloud/microsoft/activations/${id}/action`, b).then((r) => r.data),
  cloudSetSchedule: (id, syncSchedule) => http.patch(`/cloud/connections/${id}/schedule`, { syncSchedule }).then((r) => r.data),
  cloudFilePreview: (id) => http.get(`/cloud/files/${id}/preview`).then((r) => r.data),
  cloudFileContentUrl: (id) => `${API}/cloud/files/${id}/content`,
  cloudConnections: () => http.get("/cloud/connections").then((r) => r.data),
  cloudConnectionDetail: (id) => http.get(`/cloud/connections/${id}`).then((r) => r.data),
  cloudDisconnect: (id) => http.delete(`/cloud/connections/${id}`).then((r) => r.data),
  cloudGetPolicies: (connectionId) => http.get("/cloud/policies", { params: { connectionId } }).then((r) => r.data),
  cloudPutPolicies: (b) => http.put("/cloud/policies", b).then((r) => r.data),
  cloudFiles: (params) => http.get("/cloud/files", { params }).then((r) => r.data),
  cloudFileDetail: (id) => http.get(`/cloud/files/${id}`).then((r) => r.data),
  cloudResyncFile: (id) => http.post(`/cloud/files/${id}/resync`).then((r) => r.data),
  cloudSync: (connectionId) => http.post("/cloud/sync", null, { params: { connectionId } }).then((r) => r.data),
  cloudProjectSync: (projectId, connectionId) => http.post(`/cloud/projects/${projectId}/sync`, null, { params: { connectionId } }).then((r) => r.data),
  cloudAudit: (limit = 100) => http.get("/cloud/audit", { params: { limit } }).then((r) => r.data),
  cloudAiRevoke: (b) => http.post("/cloud/ai/revoke", b).then((r) => r.data),
  cloudAcceptanceProof: async (id) => {
    const res = await http.get(`/cloud/acceptances/${id}/proof`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = `preuve-cloud-connect-${id.slice(0, 8)}.json`; a.click(); URL.revokeObjectURL(url);
  },
  downloadPdf: async (docType, params) => {
    const res = await http.get(`/pdf/${docType}`, { params, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = `${docType}.pdf`; a.click();
    URL.revokeObjectURL(url);
  },
};

export const fmtMoney = (n) => new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD" }).format(n || 0);

export const LOGO = "/progere-logo.png";
